import { createContext, useContext } from 'react';

interface IDialogRouteContext {
    goBack: <T>(fn?: (...args: any) => T) => void;
}

const DialogRouteContext = createContext<IDialogRouteContext>({
    goBack: () => {},
});

const useDialogRoute = () => {
    return useContext(DialogRouteContext);
};

export { DialogRouteContext, useDialogRoute };
export type { IDialogRouteContext };
